import { Platform } from "react-native";
import StyleSheet from "react-native-media-query";

import { theme } from "../../theme/theme";
// Define your styles
export const { ids, styles } = StyleSheet.create({
  gradientBg: {
    backgroundImage: theme.colors.backgroundGradient,
  },
  coreBg: {
    backgroundColor: theme.colors.primary,
  },
  bgEffectBottom: {
    backgroundColor: theme.colors.primary,
    position: "absolute",
    bottom: -227,
    right: -101,
    transform: [{ rotate: "45deg" }],
    width: 400,
    height: 800,
    "@media (min-width: 200px)": {
      display: "none",
    },
    "@media (min-width: 700px)": {
      bottom: -472,
      right: -101,
      display: "flex",
    },
    "@media (min-width: 1150px)": {
      bottom: -472,
      right: -101,
    },
    "@media (min-width: 1281px)": {
      bottom: -472,
      right: -101,
    },
    "@media (min-width: 1441px)": {
      bottom: -472,
      right: -101,
    },
    "@media (min-width: 1681px)": {
      bottom: -472,
      right: -101,
    },
  },
  praxisBg: {
    ...Platform.select({
      web: {
        backgroundColor: theme.colors.backgroundTint,
      },
      android: {
        backgroundColor: theme.colors.backgroundTint,
      },
      ios: {
        backgroundColor: theme.colors.backgroundTint,
      },
    }),
  },
  bgEffect: {
    backgroundColor: theme.colors.primary,
    position: "absolute",
    "@media (min-width: 700px)": {
      top: -272,
      left: -101,
    },
    top: -527,
    left: -101,
    transform: [{ rotate: "45deg" }],
    width: 400,
    height: 800,
  },
  containerBG: { backgroundColor: theme.colors.secondary },
  mainContainer: {
    overflow: "hidden",

    flex: 1,
    height: "100%",
    width: "100%",
  },
  scrollArea: {
    padding: theme.spacing.cs,
    display: "flex",
    ...Platform.select({
      ios: {
        padding: Platform.OS == "ios" ? theme.spacing.cs : 0,
        display: "flex",
        flex: 1,
      },
      android: {
        display: "flex",
        flex: 1,
      },
    }),
  },

  submitBtn: {
    backgroundColor: theme.colors.button.primary,
    padding: theme.spacing.reg,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    borderRadius: theme.radius.sm,
    marginTop: theme.margin.xlg,
    marginBottom: theme.margin.xlg,
    fontWeight: theme.fontweight.medium as any,
    width: 250,
    alignSelf: "center",
  },
  deleteBtn: {
    backgroundColor: theme.colors.button.danger,
    padding: theme.spacing.reg,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    borderRadius: theme.radius.sm,
    marginTop: theme.margin.xlg,
    marginBottom: theme.margin.xlg,
    fontWeight: theme.fontweight.medium as any,
    width: 250,
    alignSelf: "center",
  },
  buttonContainer: {
    alignItems: "center",
  },
  btnText: {
    fontFamily: theme.fontFamily.robotoMedium,
    fontWeight: theme.fontweight.medium as any,
    color: theme.colors.white,
    fontSize: theme.fontsize.md,
  },
  outerBlock: {
    display: "flex",
    flex: 1,
    alignItems: "center",
  },
  innerBlock: {
    maxWidth: 600,
    paddingTop: theme.spacing.xlg,
    width: "100%",
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          // paddingHorizontal: theme.spacing.xlg,
        },
        "@media (min-width: 600px)": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          // paddingHorizontal: theme.spacing.xlg,
        },
        "@media (min-width: 600px)": {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      web: {
        paddingHorizontal: theme.spacing.xlg,
      },
    }),
  },
  heading: {
    fontFamily: theme.fontFamily.robotoSlabBold,
    marginBottom: 16,
    color: theme.colors.white,
    fontSize: theme.fontsize.mmd,
  },
  lineWrapper: {
    flexDirection: "row",
    color: theme.colors.white,
    marginBottom: 12,
  },
  line: {
    flex: 1,
    paddingLeft: 5,
  },
  lineText: {
    color: theme.colors.white,
    lineHeight: 28,
    fontWeight: "500",
    fontSize: theme.fontsize.cs,
    ...Platform.select({
      ios: {
        "@media (min-width: 700px)": {
          // iPad Pro 9.7
          fontSize: theme.fontsize.md,
        },
        "@media (min-width: 1000px)": {
          //iPad Pro 12.9
          fontSize: theme.fontsize.mmd,
        },
      },
      android: {
        "@media (min-width: 700px)": {
          // Android medium (Galaxy S4) tablet
          fontSize: theme.fontsize.cs,
        },
        "@media (min-width: 900px)": {
          // Android large tablet
          fontSize: theme.fontsize.mmd,
        },
      },
      web: {
        "@media (min-width: 1281px)": {
          fontSize: theme.fontsize.cs,
        },
        "@media (min-width: 1441px)": {
          fontSize: theme.fontsize.md,
        },
        "@media (min-width: 1681px)": {
          fontSize: theme.fontsize.mmd,
        },
      },
    }),
    fontFamily: theme.fontFamily.robotoRegular,
  },
  loader: {
    display: "flex",
    flex: 1,
    backgroundColor: theme.colors.black + 50,
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: "110%",
  },
});
